<template>
  <div>
    <v-row justify="center">
      <v-radio-group v-model="timeInterval" row hide-details>
        <v-col sm="5" md="6" lg="5" class="py-0 mr-3">
          <h4 class="grey--text my-2 pl-1">{{labels.currentPeriod}}</h4>
          <v-radio
            v-for="timeIntervalOption in actualTimeIntervalsCurrent"
            :key="timeIntervalOption.value"
            :label="timeIntervalOption.label"
            :value="timeIntervalOption.value"
            @change="handleRadioChange"
            class="text-caption font-weight-regular checkboxOveride radiobutton"
          ></v-radio>
        </v-col>
        <v-divider vertical class="mt-2"></v-divider>
        <v-col sm="6" md="6" lg="6" class="py-0">
          <h4 class="grey--text my-2 pl-1">{{labels.previousPeriod}}</h4>
          <v-radio
            v-for="timeIntervalOption in actualTimeIntervalsPrevious"
            :key="timeIntervalOption.value"
            :label="timeIntervalOption.label"
            :value="timeIntervalOption.value"
            @change="handleRadioChange"
            class="text-caption font-weight-regular checkboxOveride radiobutton"
          ></v-radio>
        </v-col>
      </v-radio-group>
    </v-row>
    <div v-if="timeInterval == 'customDate'">
      <v-row justify="center">
        <v-col sm="12" md="6" class="py-0" id="startDatePicker">
          <VueCtkDateTimePicker
            v-model="startDate"
            @input="handleStartDate"
            right
            :no-value-to-custom-elem="true"
            format="YYYY-MM-DD HH:mm:ss"
            color='dodgerblue'
            button-color="dodgerblue"
            :no-button-now="true"
            :min-date="minDate"
            :max-date="currentDay.startDate"
          >

        <v-text-field dense :label="labels.startDate" v-model="startDateDisplay" hide-details="auto"></v-text-field>
            
          </VueCtkDateTimePicker>
        </v-col>

        <v-col sm="12" md="6" class="py-0">
          <VueCtkDateTimePicker
            v-model="endDate"
            @input="handleEndDate"
            right
            :no-value-to-custom-elem="true"
            format="YYYY-MM-DD HH:mm:ss"
            color='dodgerblue'
            button-color="dodgerblue"
            :no-button-now="true"
            :min-date="startDate"
            :max-date="maxEndDate"
          >
            <v-text-field dense :label="labels.endDate" v-model="endDateDisplay" hide-details="auto"></v-text-field>
          </VueCtkDateTimePicker>
        </v-col>
      </v-row>
    </div>
    <span v-if="error" class="error--text" style="font-size:12px"> <br>{{ error }}</span>
  </div>
</template>

<script>
import store from '@/store/store'
import EventBus from '@/event-bus'
import translate from '@/utils/genTable/multilanguageHelper.js'
import { ValidationProvider } from 'vee-validate'
import Vue from 'vue'
import formatDate from '@/utils/formatDateHelper.js'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

export default {
  components: {
    ValidationProvider
  },
  name: 'DateTimeFilter',
  props: {
    showMonths: {
      type: Boolean,
      default: true
    },
    error: {
      type: String
    },
    monthPeriodInterval: {
      type: Number,
      default: 0
    }
    ,
    blockedIntervals: Array,
    dateErrors: Object
  },
  data() {
    return {
      timeInterval: 'customDate',
      startDate: null,
      endDate: null,
      maxEndDate: null,
      startDateDisplay: null,
      endDateDisplay: null,
      labels: {
        startDate: translate('Start date', 'fields.components.DateTextBox'),
        endDate: translate('End date', 'fields.components.DateTextBox'),
        currentPeriod: translate('Current', 'timeFilter'),
        previousPeriod: translate('Previous', 'timeFilter')
      },
      datePickerProps: {
        noTitle: true
      },
      textFieldProps: {
        dense: true,
        hideDetails: 'auto'
      },
      timePickerProps: {
        fullWidth: true,
        format: 'ampm',
        color: 'primary',
        class: 'timePickerOveride'
      },
      userData: JSON.parse(store.getters['user/jwtData'].UserData)
    }
  },
  mounted() {
    EventBus.$on('REPORT_BUILDER_RESET_SELECTED_FILTERS', this.resetTimeFilter)
    
    this.startDate = new Date().toISOString();
    this.endDate = new Date().toISOString();
    if(!this.monthPeriodInterval){
       this.maxEndDate = this.currentDay.endDate;
    }
    this.startDateDisplay = formatDate(this.startDate);
    this.endDateDisplay = formatDate(this.endDate);
  },
  computed: {
    endDateFormatted: function() {
      return formatDate(this.endDate)
    },
    startDateFormatted: function() {
      return formatDate(this.startDate)
    },
    actualTimeIntervalsCurrent() {
      let timeIntervals = []
      for (var period of this.timeIntervalOptionsCurrent) {
        let shouldIgnore = false
        if (this.blockedIntervals) {
          for (var excludedPeriod of this.blockedIntervals) {
            if (period.value == excludedPeriod) {
              shouldIgnore = true
              break
            }
          }
        }
        if (!shouldIgnore) timeIntervals.push(period)
      }
      return timeIntervals
    },
    actualTimeIntervalsPrevious() {
      let timeIntervals = []
      for (var period of this.timeIntervalOptionsPrevious) {
        let shouldIgnore = false
        if (this.blockedIntervals) {
          for (var excludedPeriod of this.blockedIntervals) {
            if (period.value == excludedPeriod) {
              shouldIgnore = true
              break
            }
          }
        }
        if (!shouldIgnore) timeIntervals.push(period)
      }
      return timeIntervals
    },
    timeIntervalOptionsCurrent() {
      let interval = [
        {
          label: translate('Day', 'timeFilter'),
          value: 'currentDay'
        },
        {
          label: translate('Week', 'timeFilter'),
          value: 'currentWeek'
        }
      ]

      if (this.showMonths) {
        interval.push({
          label: translate('Month', 'timeFilter'),
          value: 'currentMonth'
        })
      }

      interval.push({
        label: translate('Custom', 'timeFilter'),
        value: 'customDate'
      })

      return interval
    },
    timeIntervalOptionsPrevious() {
      let interval = [
        {
          label: translate('Day', 'timeFilter'),
          value: 'previousDay'
        },
        {
          label: translate('Week', 'timeFilter'),
          value: 'previousWeek'
        }
      ]

      if (this.showMonths) {
        interval.push({
          label: translate('Month', 'timeFilter'),
          value: 'previousMonth'
        })
      }

      return interval
    },
    previousMonthStartDate() {
      var previousMonthStartDate = new Date()
      previousMonthStartDate.setDate(1)
      previousMonthStartDate.setMonth(previousMonthStartDate.getMonth() - 1)

      return this.formatDataToIsos(previousMonthStartDate)
    },
    previousMonthEndDate() {
      var previousMonthEndDate = new Date()
      previousMonthEndDate.setDate(0)

      return this.formatDataToIsos(previousMonthEndDate)
    },
    previousMonth() {
      return {
        startDate: `${this.previousMonthStartDate} 00:00`,
        endDate: `${this.previousMonthEndDate} 23:59`
      }
    },
    previousWeek() {
      var d = new Date()

      var to = d.setTime(
        d.getTime() - (d.getDay() ? d.getDay() : 7) * 24 * 60 * 60 * 1000
      )
      var from = d.setTime(d.getTime() - 6 * 24 * 60 * 60 * 1000)

      return {
        startDate: `${this.formatDataToIsos(new Date(from))} 00:00`,
        endDate: `${this.formatDataToIsos(new Date(to))} 23:59`
      }
    },
    previousDay() {
      var date = new Date()
      date.setDate(date.getDate() - 1)

      return {
        startDate: `${this.formatDataToIsos(date)} 00:00`,
        endDate: `${this.formatDataToIsos(date)} 23:59`
      }
    },
    currentDay() {
      var currentDate = new Date()

      return {
        startDate: `${this.formatDataToIsos(new Date())} 00:00`,
        endDate: `${this.formatDataToIsos(new Date())} ${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}`
      }
    },
    minDate() {
      var today = new Date()
      var minYear = today.getFullYear()
      var minMonth = today.getMonth() - 6
      var minDate = today.getDate()

      if (this.userData && this.userData.IsAdmin) {
        minYear = minYear - 2
        minMonth = 0
        minDate = 1
      }

      return `${this.formatDataToIsos(new Date(minYear, minMonth, minDate))} 00:00`
    },
    currentWeek() {
      var curr = new Date()
      //var first = new Date(curr.setDate(curr.getDate() - curr.getDay()))

      const first = this.getStartOfWeek(curr)
      //var last = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6))
      const last = curr
      return {
        startDate: `${this.formatDataToIsos(first)} 00:00`,
        endDate: `${this.formatDataToIsos(last)} ${String(curr.getHours()).padStart(2, '0')}:${String(curr.getMinutes()).padStart(2, '0')}`
      }
    },
    currentMonth() {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 2)

      return {
        startDate: `${this.formatDataToIsos(firstDay)} 00:00`,
        endDate: `${this.formatDataToIsos(date)} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
      }
    }
  },
  methods: {
    getStartOfWeek(d) {
      d = new Date(d)
      //d.setHours(0, 0, 0, 0)
      var day = d.getDay()
      const diff = d.getDate() - day + (day == 0 ? -6 : 1)
      return new Date(d.setDate(diff))
    },

    getCurentDate() {
      return this.formatDataToIsos(new Date())
    },
    formatDataToIsos(date) {
      return date.toISOString().substr(0, 10)
    },
    convertToUtc(date) {
      return new Date(date).toISOString()
    },
    resetTimeFilter() {
      this.startDate = new Date().toISOString()
      this.endDate = new Date().toISOString()
    },
    handleRadioChange() {
      var data = {}
      setTimeout(() => {
        switch (this.timeInterval) {
          case 'currentDay':
            data = this.currentDay
            break
          case 'currentWeek':
            data = this.currentWeek
            break
          case 'currentMonth':
            data = this.currentMonth
            break
          case 'previousDay':
            data = this.previousDay
            break
          case 'previousWeek':
            data = this.previousWeek
            break
          case 'previousMonth':
            data = this.previousMonth
            break
          case 'customDate':
            this.resetTimeFilter()
            data.startDate = this.startDate
            data.endDate = this.endDate
            break
          default:
            throw new Error(`Unsuported time interval ${this.timeInterval}.`)
        }

        this.startDate = data.startDate
        this.endDate = data.endDate

        this.handleStartDate()
        this.handleEndDate()
      }, 0)
    },
    handleStartDate() {
      if (this.monthPeriodInterval) {
          this.checkIntervalBetweenStartAndEndDate(this.startDate);
      }
      this.$emit('input', {
          startDate: this.toUtc(this.startDate),
          endDate: this.toUtc(this.endDate)
      });
    },
    handleEndDate() {
      if (this.monthPeriodInterval) {
          this.checkIntervalBetweenStartAndEndDate(this.startDate);
      }
      this.$emit('input', {
          startDate: this.toUtc(this.startDate),
          endDate: this.toUtc(this.endDate)
      });
    },
    checkIntervalBetweenStartAndEndDate(date)
    {
      let dateFromIso = new Date(date);
      let currentDate = new Date(this.currentDay.endDate);
      
      dateFromIso.setMonth(dateFromIso.getMonth() + this.monthPeriodInterval);
      dateFromIso.setHours(23);
      dateFromIso.setMinutes(59);

      if(dateFromIso >= currentDate){
          this.maxEndDate = currentDate.toISOString();
      }else{
          this.maxEndDate = dateFromIso.toISOString();
      }

    },
    toUtc(date) {
      return new Date(date.replace(" ", "T")).toISOString();
    }
  },
  watch: {
    startDate: {
      handler() {
        this.startDateDisplay = formatDate(this.startDate.replace(" ", "T"));
      }
    },
    endDate: {
      handler() {
        this.endDateDisplay = formatDate(this.endDate.replace(" ", "T"));
      }
    }
  }
}
</script>
<style scoped>
.checkboxOveride {
  margin-top: 0px;
  padding-top: 0px;
}
.checkboxOveride >>> div {
  margin-right: 0px;
}
.clearColumnPadding {
  padding-top: 1px;
  padding-bottom: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.radiobutton >>> div > i {
  font-size: 16px;
}
.radiobutton >>> div > div {
  height: 18px;
  width: 18px;
  left: -4px;
  top: calc(50% - 16px);
}
</style>
